import {
    ENRICHMENT_CATEGORY_TYPE_CUSTOM,
    ENRICHMENT_CATEGORY_TYPE_LIVEVOTING,
    ENRICHMENT_CATEGORY_TYPE_PROFILE,
    ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE,
    ENRICHMENT_CATEGORY_TYPE_VOTE,
} from 'common-data-handling';
import _ from 'lodash';

export default function (state, props) {
    let event = state.events[props.eventId].event,
        headerColor = event ? event.settings.primary_color : null,
        category = event
            ? _(event.enrichment_categories).find(enCat => {
                  return enCat.category == props.cat;
              })
            : null,
        headerTitle = category ? category.label : null,
        introText = category ? category.intro_text : null,
        questions = _(state.events[props.eventId].enrichments.questions)
            .filter(question => {
                return question.question.category == props.cat;
            })
            .sortBy('number')
            .value();

    return {
        i18n: state.i18n.translations,
        event,
        questions,
        category,
        eventId: props.eventId,
        returnURL: props.returnURL || '/events/' + props.eventId,
        headerColor,
        headerTitle,
        introText,
        user: state.session.user,
        catId: props.catId,
        cat: props.cat,
        notifications: _(state.events[props.eventId].notifications.eventMessage)
            .filter(notif => {
                let type = _.get(notif, 'content.data.target', '').split('/')[0];
                return (
                    (props.catId == ENRICHMENT_CATEGORY_TYPE_PROFILE && type == 'enrich_profile') ||
                    (props.catId == ENRICHMENT_CATEGORY_TYPE_VOTE && type == 'vote') ||
                    (props.catId == ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE && type == 'questionaire') ||
                    (props.catId == ENRICHMENT_CATEGORY_TYPE_CUSTOM && type == 'custom_enrich') ||
                    (props.catId == ENRICHMENT_CATEGORY_TYPE_LIVEVOTING && type == 'live_voting_enrich')
                );
            })
            .reject(notif => notif.read)
            .value(),
        allQuestionsAnswered: !_(questions).find(question => !question.answer.length),
        noQuestionsAnswered: !_(questions).find(question => question.answer.length),
    };
}
